var slice = /*#__PURE__*/require('../slice');

function dropLastWhile(pred, xs) {
  var idx = xs.length - 1;
  while (idx >= 0 && pred(xs[idx])) {
    idx -= 1;
  }
  return slice(0, idx + 1, xs);
}
module.exports = dropLastWhile;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_dropLastWhile.js
// module id = 906
// module chunks = 0